import React, {useState} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getQuotaForApproval, rejectMultiple, setState, Upload } from "./quotaSlice";
import { Button, TextField, Typography, Grid } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function RejectSelectedModal() {
   const dispatch = useDispatch();
   const [uploadedEditFile, setuploadedEditFile] = useState([]);
   const {
      rejectSelModalOpen,
      rejectSelectedComment,
      selectedRows,
      quotaForApprovalTable,
      quotaForApproval,
      selectedCountryID,
      selectedPeriod,
      selectedQuotaStatus,
      searchText
   } = useSelector((store) => store.quota);

   function handleClose() {
      dispatch(setState("rejectSelModalOpen", false));
      dispatch(setState("rejectSelectedComment", ''));
      dispatch(setState("files",[]));
		setuploadedEditFile([]);
      dispatch(setState("filepaths",[]));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("rejectSelectedComment", comment));
   }

   function search() {
      dispatch(setState("quotaCustomerBreakdown", null));
      dispatch(setState("quotaDetailsTable", null));
      dispatch(setState("rejectSelectedComment", ''));
      dispatch(setState("selectedRows", []));
      dispatch(setState("files",[]));
		setuploadedEditFile([]);
      dispatch(setState("filepaths",[]));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;

      const obj = {
         countryId,
         period,
         quotaStatus,
         logedUser,
         searchText: searchText
      };
      dispatch(getQuotaForApproval(obj));
   }

   function rejectSelected() {

      const user = JSON.parse(localStorage.getItem("data"));
      let quotaList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = quotaForApprovalTable.rows[selectedRows[i]].quotaId;
         let quota = quotaForApproval.find((item) => item.quotaId === id);
         if (quota.revisedQuota <= 0) {
            showMessage("Please enter the revised quota", "info");
            return;
         }
         quota = {
            ...quota,
            rejectComments: rejectSelectedComment,
         }
         const obj = {
            ...quota,
            user,
         };
         quotaList.push(obj);
      }
      console.log("Approve_Quota_RejectSelected", quotaList);
      dispatch(Upload({method : "POST"})).then(() => {
      dispatch(rejectMultiple(quotaList)).then(() => {
         handleClose();
         search();
      });

   });
   }
   const showMessage = (message, severity) => {
      dispatch(setState("message", message));
      dispatch(setState("severity", severity));
      dispatch(setState("messageOpen", true));
   };
   const handleFileUpload = (event) => {
      const fileObj = event.target.files[0];
      let files = [...uploadedEditFile];
      files.push(fileObj);
      setuploadedEditFile(files);
      dispatch(setState("files", files));
    };
  
    const handleDelete = (name) => {
      const files = uploadedEditFile.filter((file) => file.name !== name);
      setuploadedEditFile(files);
      dispatch(setState("files", files));
    };

   return (
      <Box>
         <Modal open={rejectSelModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
                  size="large"
                  multiline
                  rows={6}
                  style={{overflowY:'auto'}}
                  value={rejectSelectedComment}
                  onChange={setComment}
               />
               <br />
               <Grid item>
                  <Box>
                     <input
                        type="file"
                        onChange={handleFileUpload}
                        style={{ display: 'none' }}
                        id="fileInput"
                        onclick="fileInput.value = null"
                        value=""
                     />
                     <label htmlFor="fileInput">
                        <Button
                           variant="contained"
                           sx={{
										bgcolor: "grey.lighter",
										color: "darkred.light",
										textTransform: "none",
										mt: 1,
										"&:hover": {
											bgcolor: "darkred.main",
											color: "white.main",
										},
									}}
                           component="span"
                        >
                           Upload File
                        </Button>
                     </label>
                  </Box>
               </Grid>
               <Grid>
                  {uploadedEditFile.map((file) => (
							<Box sx={{ mt: 2, borderBottom: 0.25, borderColor: "#e0e0e0" }}>
								<div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<span>{file.name}</span>
									{/* <Button variant="outlined" color="secondary" onClick={() => handleDelete(file.name)}> */}
									<DeleteIcon onClick={() => handleDelete(file.name)} sx={{ cursor: "pointer" }} />
									{/* </Button> */}
								</div>
							</Box>
						))}
               </Grid>
               <br />
               <Box
                  sx={{
                     display: "flex",
                     flexDirection: "row",
                     justifyContent: "flex-end",
                  }}
               >
                  <Button
                        sx={{
                           bgcolor: "darkred.light",
                           color: "white.main",
                           textTransform: "none",
                           fontWeight: "bold",
                           mt: 1,
                           mr: 2,
                           "&:hover": {
                           bgcolor: "darkred.main",
                           color: "white.main",
                           },
                        }}
                     onClick={handleClose}
                  >
                     Close
                  </Button>

                  <Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
                        "&:hover": {
                        bgcolor: "darkred.main",
                        color: "white.main",
                        },
                     }}
                     
                     onClick={rejectSelected}
                  >
                     Reject
                  </Button>
               </Box>

            </Box>
         </Modal>
      </Box>
   );
}
